import type { AxiosInstance } from 'axios'
import type { DocumentDetailType, DocumentType } from 'src/types/documents'


export class DocumentsApi {
  api: AxiosInstance

  urls = {
    documents: () => 'documents/' as const,
    document: (slug: DocumentType['slug']) => `documents/${slug}/`,
  }

  constructor (api: AxiosInstance) {
    this.api = api
  }

  getDocuments = async (): Promise<DocumentType[]> => {
    const response = await this.api.get<DocumentType[]>(this.urls.documents())
    return response.data
  }

  getDocument = async (slug: DocumentType['slug']): Promise<DocumentDetailType> => {
    const response = await this.api.get<DocumentDetailType>(this.urls.document(slug))
    return response.data
  }
}
